const axios = require('axios');

const FileStatus_NotUploaded = 0;
const FileStatus_Uploading = 1;
const FileStatus_Uploaded = 2;

class MultiUploader {
	constructor(fileInfos, config) {
		if (!Array.isArray(fileInfos)) {
			throw new Error('INVALID_PARAM');
		}

		this.files = [];
		for (let i = 0; i < fileInfos.length; i++) {
			let fileObj = {
				url: fileInfos[i].url,
				file: fileInfos[i].file,
				contentType: fileInfos[i].contentType,
				fileName: fileInfos[i].fileName,
				fileSize: fileInfos[i].fileSize,
				status: FileStatus_NotUploaded,
				loadedSize: 0,
				lastLoadedSize: 0,
				retryCount: 0 
			};

			// sort this.files in the decreasing order of fileSize
			// insertion sort algorithm
			//
			let inserted = false;
			for (let j = 0; j < this.files.length; j++) {
				if (this.files[j].fileSize < fileObj.fileSize) {
					this.files.splice(j, 0, fileObj);
					inserted = true;
					break;
				}
			}

			if (!inserted) {
				this.files.push(fileObj);
			}
		}

		this.config = {
			maxConcurrency: config && config.maxConcurrency ? config.maxConcurrency : 5,
			maxRetry: config && config.maxRetry ? config.maxRetry : 3,
			monitorInterval: config && config.monitorInterval ? config.monitorInterval : 3000,
			cancelThreshold: config && config.cancelThreshold ? config.cancelThreshold : 0,
		};

		this.isUploading = false;
	}

/*
	simulateUpload(resolve, reject, idx) {
		if (idx != 10) {
			console.log("COMPLETED: " + idx);
			resolve(idx);
		}
		else {
			console.log("FAILED: " + idx);
			reject(idx);
		}
	}
*/

	getFileData(idx) {
		return this.files[idx].file;
	}

	uploadFile(idx) {
		let uploader = this;

		return new Promise((resolve, reject) => {
			uploader.files[idx].status = FileStatus_Uploading;

			//let uploadTime = Math.floor(5000 * Math.random()) + 3000;
			//setTimeout(this.simulateUpload.bind(this), uploadTime, resolve, reject, idx);

			let data = this.getFileData(idx);

			uploader.files[idx].cancelTokenSource = axios.CancelToken.source();

			axios({
				method: 'put',
				url: uploader.files[idx].url,
				data: data,
				maxContentLength: Infinity,
				maxBodyLength: Infinity,
				headers: {
					'Content-Type': uploader.files[idx].contentType
				},
				cancelToken: uploader.files[idx].cancelTokenSource.token,
				onUploadProgress: progressEvent => {
					console.log("upload progress: idx = " + idx + ", loadedSize = " + progressEvent.loaded);
					uploader.files[idx].loadedSize = progressEvent.loaded;
				}
			})
			.then(function (response) {
				console.log("upload succeeded");
				resolve(idx);
			})
			.catch(function (error) {
				if (axios.isCancel(error)) {
					console.log("upload canceled");
					reject('canceled');
				}
				else {
					console.log("upload failed");
					reject(idx);
				}
			})
		});
	}

	monitor() {
		for (let i = 0; i < this.files.length; i++) {
			if (this.files[i].loadedSize < this.files[i].fileSize &&
				this.files[i].loadedSize - this.files[i].lastLoadedSize < this.config.cancelThreshold) {
				console.log("upload is too slow: file = " + this.files[i].fileName);
				// [TODO] shall we cancel this upload?
				//this.abortEntireUpload();
			}
			this.files[i].lastLoadedSize = this.files[i].loadedSize;
		}
	}

	setup(promises, idxForPromises) {
		let i = 0;

		while (i < this.files.length && i < this.config.maxConcurrency) {
			promises.push(this.uploadFile(i));
			idxForPromises.push(i);
			i++;
		}
		return i;
	}

	abortEntireUpload() {
		console.log("aborting entire upload");
		for (let i = 0; i < this.files.length; i++) {
			if (this.files[i].status === FileStatus_Uploading) {
				this.files[i].cancelTokenSource.cancel();
			}
		}
		this.isAborted = true;
		console.log("entire upload aborted");
	}

	async upload() {
		if (this.isUploading) {
			console.log("already uploading");
			return;
		}
		this.isUploading = true;
		this.isAborted = false;

		let promises = [];
		let idxForPromises = [];
		let idx = this.setup(promises, idxForPromises);

		let monitorTimer = setInterval(this.monitor.bind(this), this.config.monitorInterval);

		while (promises.length > 0 && !this.isAborted) {
			try {
				//console.log("promises.length = " + promises.length);

				let completedIdx = await Promise.race(promises);
				console.log("completedIdx = " + completedIdx);

				this.files[completedIdx].status = FileStatus_Uploaded;
				this.files[completedIdx].loadedSize = this.files[completedIdx].fileSize;

				for (let i = 0; i < idxForPromises.length; i++) {
					if (idxForPromises[i] === completedIdx) {
						if (idx < this.files.length) {
							idxForPromises[i] = idx;
							promises[i] = this.uploadFile(idx);
							idx++;
						}
						else {
							idxForPromises.splice(i, 1);
							promises.splice(i, 1);
						}
						break;
					}
				}
			}
			catch (e) {
				//console.log("e = " + JSON.stringify(e));
				if (e === 'canceled') break;

				let failedIdx = e;

				// retrying...
				for (let i = 0; i < idxForPromises.length; i++) {
					if (idxForPromises[i] === failedIdx) {
						console.log("failedIdx = " + failedIdx + ", retryCount = " +
							this.files[failedIdx].retryCount);

						if (this.files[failedIdx].retryCount < this.config.maxRetry) {
							promises[failedIdx] = this.uploadFile(failedIdx);
							this.files[failedIdx].retryCount++;
						}
						else {
							idxForPromises.splice(i, 1);
							promises.splice(i, 1);

							this.abortEntireUpload();
						}
						break;
					}
				}
			}
		}

		clearInterval(monitorTimer);
		this.isUploading = false;

		// debug output
		//
		for (let i = 0; i < this.files.length; i++) {
			console.log("idx: " + i + ", fileSize: " + this.files[i].fileSize +
				", loadedSize: " + this.files[i].loadedSize + ", retryCount: " + this.files[i].retryCount);
		}
		return !this.isAborted;
	}

	getProgress() {
		let totalFileSize = 0;
		let totalLoadedSize = 0;
		for (let i = 0; i < this.files.length; i++) {
			totalFileSize += this.files[i].fileSize;
			totalLoadedSize += this.files[i].loadedSize;
		}
		return totalLoadedSize / totalFileSize;
	}
}

//module.exports = SmartUploader;
export default MultiUploader;

/*
const fs = require('fs');

var fileNames= [
	'test-video.mp4',
	'test-music.mp4',
	'boss (1).mp4',
	'sample_960x540.webm',
	'sample_960x400_ocean_with_audio.webm',
	'video3-remux.mp4'
];

var baseDir = '/home/madincom/dev/dip-api/test/';
var fileInfos = [];

for (let i = 0; i < fileNames.length; i++) {
	if (i == 0) {
		// intentional failure for testing
		fileInfos.push({
			url: 'https://s3.ap-northeast-2.amazonaws.com/' + fileNames[i],
			file: fs.readFileSync(baseDir + fileNames[i]),
			contentType: 'video',
			fileName: fileNames[i],
			fileSize: fs.statSync(baseDir + fileNames[i]).size,
		});
	}
	else {
		fileInfos.push({
			url: 'https://s3.ap-northeast-2.amazonaws.com/test.exax-dx.com/' + fileNames[i],
			file: fs.readFileSync(baseDir + fileNames[i]),
			contentType: 'video',
			fileName: fileNames[i],
			fileSize: fs.statSync(baseDir + fileNames[i]).size,
		});
	}
}

var config = {
	maxConcurrency: 5,
	maxRetry: 3,
	monitorInterval: 3000,
	cancelThreshold: 50000,
};

//var uploader = new SmartUploader(fileInfos, config);
var uploader = new SmartUploader(fileInfos);

var run = async () => {
	console.log("progress = " + uploader.getProgress());
	await uploader.upload();
	console.log("progress = " + uploader.getProgress());
};

run();
*/
